import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Image, message } from 'antd';
import { debounce } from 'lodash';
import { workwiseServices } from '../../../Api/api';
import defaultProfileImage from '../../../assets/defult-profile-logo.png';

const SEARCH_DEBOUNCE_MS = 300;
const AVATAR_SIZE = 30;
const PEOPLE_TYPE = 1;
const SEARCH_PAYLOAD = {
    notRequired: [],
    pageNo: 1,
    pageSize: 20,
    referenceId: '00000000-0000-0000-0000-000000000000',
    removeSelf: true,
    types: [PEOPLE_TYPE],
};

const SuggestionOption = ({ member }) => (
    <div className="member-option">
        <Avatar
            size={AVATAR_SIZE}
            src={<Image src={member.image || defaultProfileImage} preview={false} />}
        />
        <div className="member-info">
            <span className="name">{member.name}</span>
            <br />
            <span className="designation">{member.designation}</span>
        </div>
    </div>
);

/**
 * Debounced people search for the invite field, leaving out anyone already on
 * the map. Returns AutoComplete `options` (key = member id, value = name).
 */
export const useMemberSuggestions = (existingMembers) => {
    const [options, setOptions] = useState([]);
    // Read at answer time, so a member added since the search started is still left out.
    const membersRef = useRef(existingMembers);
    membersRef.current = existingMembers;

    const search = useRef(
        debounce(async (text) => {
            try {
                const res = await workwiseServices.getAllSuggestion({ ...SEARCH_PAYLOAD, search: text });
                const isMember = (person) => (membersRef.current || []).some((member) => member.id === person.id);
                setOptions(res.data.data.filter((person) => !isMember(person)).map((person) => ({
                    key: person.id,
                    value: person.name,
                    label: <SuggestionOption member={person} />,
                })));
            } catch (error) {
                message.error('something went wrong...');
            }
        }, SEARCH_DEBOUNCE_MS)
    ).current;

    useEffect(() => () => search.cancel(), [search]);

    const clear = () => {
        search.cancel();
        setOptions([]);
    };

    return { options, search, clear };
};
